import { useTranslation } from "react-i18next";
import { Icon, Tab } from "semantic-ui-react";

import { AttachmentsPreview, DATE_FORMATS_FNS } from "components";
import "modules/AppointmentDetails/components/Interventions/components/Attachments/Attachments.scss";
import { getAttachmentIcon } from "modules/AppointmentDetails/utils";
import { formatDate } from "utils/dateHelperFunctions";

import type { DiagnoseOverviewAttachment, InterventionAttachment } from "models";

type AttachmentsProps = {
  attachments?: (InterventionAttachment | DiagnoseOverviewAttachment)[];
};

export const Attachments = ({ attachments }: AttachmentsProps) => {
  const { t } = useTranslation();

  const renderListView = () =>
    !!attachments?.length && (
      <div className="attachment-container">
        {attachments.map(item => (
          <div key={item.id} className="attachment-view">
            <div className="attachment-name">
              <Icon className={getAttachmentIcon(item.url)} />
              <p className="ellipsis">{item.name || (item.created_on && formatDate(item.created_on, DATE_FORMATS_FNS.dateMonthYear))}</p>
            </div>
            <div className="attachment-delete">
              {item.created_on && <p>{`${t("v8_uploaded_on", "Uploaded on")} ${formatDate(item.created_on, DATE_FORMATS_FNS.dateMonthYearTime)}`}</p>}
            </div>
          </div>
        ))}
      </div>
    );

  const renderGalleryView = () =>
    !!attachments?.length && (
      <div className="attachment-container">
        <AttachmentsPreview attachments={attachments} canDelete={false} />
      </div>
    );

  return (
    <div className="Attachments">
      <Tab
        style={{ padding: "0" }}
        menu={{ attached: false, tabular: false }}
        panes={[
          { menuItem: { key: "gallery", icon: "photo film", content: t("v8_gallery", "Gallery") }, render: () => <Tab.Pane>{renderGalleryView()}</Tab.Pane> },
          { menuItem: { key: "list", icon: "list", content: t("v8_list", "List") }, render: () => <Tab.Pane>{renderListView()}</Tab.Pane> }
        ]}
        grid={{ paneWidth: 16, tabWidth: 8 }}
      />
    </div>
  );
};
